@if ({ documents: documents$ | async, isLoading: isLoading$ | async }; as data) {
  <div class="document-menu">
    @if (data.isLoading === false) {
      @if (data.documents.length > 0) {
        <div>
          <button mat-button color="primary" disableRipple="true" [matMenuTriggerFor]="documentMenu">
            <div>
              <mat-icon> cloud_download</mat-icon>
            </div>
            <span>{{ 'sidebar.documents' | transloco }}</span>
          </button>
          <mat-menu #documentMenu="matMenu">
            @for (document of data.documents; track document) {
              <button mat-menu-item (click)="downloadDocument(document)">
                {{ document.filename }}
              </button>
            }
          </mat-menu>
        </div>
      }
    } @else {
      <mat-spinner class="white-spinner" [diameter]="30"></mat-spinner>
    }
  </div>
}
